<template>
  <div class="app-center">
    <div class="banner">
      <div class="v-page-center div-center text-center">
        <div class="title">查看我们支持的应用系统</div>
        <div class="sub-title">
          <div>
            截止目前，我们与32家供应商进行深入合作，接入100+款设备，每年为5万个家庭提供各项服务并在持续丰富我们的产品。
          </div>
          <div>我们也支持集成您的自有设备，如需合作请通过页面底部的联系方式与我们取得联系。</div>
        </div>
      </div>
    </div>
    <div class="content v-page-center div-center flex">
      <div class="nav-list flex-auto">
        <div
          class="app-item text-center"
          :class="[currIdx === idx ? 'active' : '']"
          v-for="(app, idx) in navs"
          :key="app.id">
          <span class="pointer" @click="handleTextClick(app, idx)">
            {{ app.name }}
          </span>
        </div>
      </div>
      <div class="cards">
        <a-spin :spinning="loading" style="height: 100%">
          <template v-if="appList.length">
            <div class="cards-section flex-wrap">
              <div
                class="card-item pointer flex-column flex-side-center"
                @click="toDetailPage(app)"
                v-for="app in appList"
                :key="app.appId">
                <img class="icon" :src="appUrl(app)" :alt="app.name" />
                <span class="text">{{ app.name }}</span>
              </div>
            </div>
          </template>
          <template v-else>
            <div class="flex-center" style="height: 300px">
              <a-empty :image="Empty.PRESENTED_IMAGE_SIMPLE" description="暂无数据" />
            </div>
          </template>
          <a-icon slot="indicator" type="loading" style="font-size: 32px" spin />
        </a-spin>
      </div>
    </div>

    <AppDetail ref="appDetailRef" />
  </div>
</template>

<script>
import { Empty } from 'ant-design-vue'
import scroll from '@/mixins/scroll'
import { appCenterNavs } from '@/config'
import AppDetail from './AppDetail.vue'
import { getAppList } from '@/api'

export default {
  name: 'AppCenter',
  mixins: [scroll],
  components: {
    AppDetail,
  },
  data() {
    return {
      Empty,
      currIdx: 0,
      loading: false,
      appList: [],
      navs: appCenterNavs,
    }
  },
  computed: {
    appUrl() {
      return (app) => {
        const { extInfo } = app
        return extInfo?.cover || ''
      }
    },
  },
  activated() {
    this.resetState()
    this.getAppList()
  },
  deactivated() {
    this.resetState()
  },
  methods: {
    async getAppList(currIdx = 0) {
      try {
        this.loading = true
        const classify = this.navs[currIdx].value
        const { code, data } = await getAppList({ classify })
        if (code === 0) {
          this.appList = data?.length ? data : []
        }
      } catch (err) {
        console.error(err)
      } finally {
        this.loading = false
      }
    },
    resetState() {
      this.currIdx = 0
      this.appList = []
    },
    handleTextClick(app, idx) {
      this.currIdx = idx
      this.getAppList(idx)
    },
    toDetailPage(app) {
      this.$refs?.appDetailRef?.showModal(app)
    },
  },
}
</script>

<style scoped lang="scss">
::v-deep .ant-spin-container {
  height: 100% !important;
}

$app-item-width: 180px;
$card-width: 180px;
$card-gap: 22px;

.fixed-left-nav {
  position: fixed;
  top: 122px;
}
.cards-left-gap {
  margin-left: $app-item-width;
}
.app-center {
  .banner {
    padding-top: 120px;
    height: 230px;
    background: url('~@/assets/image/app-center/app-banner.png') no-repeat center / 100% 100%;
    .title {
      margin-bottom: 8px;
      @include fc(28px, 500, #061d44);
    }
    .sub-title {
      @include fc(16px, 400, #626973);
    }
  }

  .content {
    padding: 40px 0;
    .nav-list {
      .app-item {
        width: $app-item-width;
        line-height: 54px;
        background: rgba(242, 245, 248, 0);
        border-right: 2px solid #f2f5f8;
        @include fc(16px, 400, $secondary-color);
        &:hover {
          color: $primary-color;
        }
      }
    }
    .cards {
      padding-left: 24px;
      width: calc(100% - $app-item-width);

      .cards-section {
        .card-item {
          margin-right: $card-gap;
          margin-bottom: $card-gap;
          padding: 16px;
          width: $card-width;
          height: 212px;
          background: #fafcff;
          border-radius: 8px;
          border: 1px solid #e6e9f2;
          box-shadow: 0 10px 14px 6px rgba(0, 0, 0, 0.04);
          &:hover {
            box-shadow: -2px 2px 8px 2px #e1e1e1;
            transform: translateY(-1px);
            transition: all 0.2s linear;
          }
          .icon {
            margin-bottom: 10px;
            width: 148px;
            height: 122px;
          }
          .text {
            @include fc(16px, 500, $secondary-color);
          }
          &:nth-child(5n) {
            margin-right: 0;
          }
        }
      }
    }
  }
  .active {
    font-weight: 500 !important;
    color: $primary-color !important;
    border-right: 2px solid $primary-color !important;
  }
}
</style>
